import { IDeleteIndicadorObraUseCase } from "../../../presentation/useCases/delete/delete_indicador_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteIndicadorObraUseCase
 */

export class DeleteIndicadorObraUseCase implements IDeleteIndicadorObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteIndicadorObra(
    idObraIndicador: number,
  ): Promise<void> {
    await this.repository.deleteIndicadorObra(idObraIndicador);
  }
}
